module.exports = __webpack_public_path__ + "static/media/adcolony-logo-grey.bfbfbef4.png";